import { render, staticRenderFns } from "./pos-addEmployee.vue?vue&type=template&id=76f668ac"
import script from "./pos-addEmployee.vue?vue&type=script&lang=js"
export * from "./pos-addEmployee.vue?vue&type=script&lang=js"
import style0 from "./pos-addEmployee.vue?vue&type=style&index=0&id=76f668ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports